'use client'

import localFont from 'next/font/local'
import { Inter } from 'next/font/google'
import One55SymbolWhite from 'src/app/assets/icons/ico-155-symbol.svg'

type Props = Readonly<{
  error: Error & { digest?: string }
}>

const inter = Inter({
  subsets: ['latin'],
  display: 'swap',
  weight: ['400', '600'],
  preload: false
})
const formulaBold = localFont({
  variable: '--font-formula',
  display: 'swap',
  preload: false,
  src: [
    { path: 'assets/fonts/formula1-bold.woff2', weight: '600', style: 'normal' },
    { path: 'assets/fonts/formula1-regular.woff2', weight: '400', style: 'normal' }
  ]
})

export default function GlobalError({ error }: Props) {
  // Send error to browser console.
  console.error(error)

  // Check if it's a chunk load error
  const isChunkError =
    error.message.includes('ChunkLoadError') ||
    error.message.toLowerCase().includes('failed to fetch')

  const handleReload = () => {
    const currentUrl = new URL(window.location.href)
    currentUrl.searchParams.set('reload', Date.now().toString()) // Cache-busting param
    window.location.href = currentUrl.toString()
  }

  return (
    <html lang="en">
      <body className={`${inter.className} ${formulaBold.variable} formula-font-enabled`}>
        <main>
          <div className="race-loading-indicator-outer">
            <div className="race-loading-indicator">
              <div className="race-loading-indicator__inner">
                {/* Prevent external component failures */}
                {typeof One55SymbolWhite === 'function' ? <One55SymbolWhite /> : null}
                <div className="text">
                  <span className="primary">
                    {isChunkError ? 'Update Available' : 'Something went wrong'}
                  </span>
                  <span className="secondary no-transform">
                    {isChunkError
                      ? 'A new version of the game is available. Please refresh the page.'
                      : 'An unexpected error occurred. Please try again.'}
                  </span>
                  <button onClick={handleReload} type="button">
                    <span>{isChunkError ? 'Reload' : 'Try again'}</span>
                  </button>
                </div>
              </div>
            </div>
            <div className="loading-indicator__background">
              <img alt="" src="/assets/marbles-racetrack-loading-screen.webp" />
            </div>
          </div>
        </main>
      </body>
    </html>
  )
}
